<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g id="exchange-icon" transform="translate(-3 -1)">
      <path
        id="Path_8183"
        data-name="Path 8183"
        d="M17.524,11.952,21,8.476,17.524,5M9,8.48H21m-8.524,6.368L9,18.324,12.476,21.8M21,18.32H9"
        fill="none"
        :stroke="clr ? clr : '#56606b'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
  </svg>
</template>
